import type { QuestionDraft } from './questionTypes'

const MIN_ANSWERS = 2
const MIN_QUESTIONS_FOR_DONE_TEST = 2
const MIN_QUESTIONS_FOR_DONE_SURVEY = 1

export function countFilledOptions(q: QuestionDraft): number {
  return q.options.filter((o) => o.text.trim().length > 0).length
}

export function isQuestionValidForSave(q: QuestionDraft): boolean {
  const kind = q.kind ?? (q.answerMode === 'multiple' ? 'multiple' : 'single')

  if (kind === 'info') {
    return q.text.trim().length > 0
  }

  if (!q.text.trim()) {
    return false
  }

  if (kind === 'text_short' || kind === 'text_long') {
    return true
  }

  if (kind === 'scale') {
    const min = q.scaleMin ?? 1
    const max = q.scaleMax ?? 5
    return max > min
  }

  if (kind === 'matrix') {
    const rows = (q.matrixRows ?? []).filter((r) => r.trim())
    const max = q.scaleMax ?? 5
    const cols = (q.matrixCols ?? []).filter((c) => c.trim())
    const hasCols = cols.length >= 2 || max >= 5
    return rows.length >= 1 && hasCols
  }

  return countFilledOptions(q) >= MIN_ANSWERS
}

export function isQuestionValidForDone(q: QuestionDraft): boolean {
  return q.saved && isQuestionValidForSave(q)
}

export function areAllQuestionsValidForDone(
  questions: QuestionDraft[],
  productKind: 'test' | 'questionnaire' = 'test'
): boolean {
  if (productKind === 'questionnaire') {
    const answerable = questions.filter((q) => (q.kind ?? 'single') !== 'info')
    if (answerable.length < MIN_QUESTIONS_FOR_DONE_SURVEY) {
      return false
    }
    return questions.every(isQuestionValidForDone)
  }
  if (questions.length < MIN_QUESTIONS_FOR_DONE_TEST) {
    return false
  }
  return questions.every(isQuestionValidForDone)
}
import type { QuestionDraft } from './questionTypes'

const MIN_ANSWERS = 2
const MIN_QUESTIONS_FOR_DONE_TEST = 2
const MIN_QUESTIONS_FOR_DONE_SURVEY = 1

export function countFilledOptions(q: QuestionDraft): number {
  return q.options.filter((o) => o.text.trim().length > 0).length
}

export function isQuestionValidForSave(q: QuestionDraft): boolean {
  const kind = q.kind ?? (q.answerMode === 'multiple' ? 'multiple' : 'single')

  if (kind === 'info') {
    return q.text.trim().length > 0
  }

  if (!q.text.trim()) {
    return false
  }

  if (kind === 'text_short' || kind === 'text_long') {
    return true
  }

  if (kind === 'scale') {
    const min = q.scaleMin ?? 1
    const max = q.scaleMax ?? 5
    return max > min
  }

  if (kind === 'matrix') {
    const rows = (q.matrixRows ?? []).filter((r) => r.trim())
    const max = q.scaleMax ?? 5
    const cols = (q.matrixCols ?? []).filter((c) => c.trim())
    const hasCols = cols.length >= 2 || max >= 5
    return rows.length >= 1 && hasCols
  }

  return countFilledOptions(q) >= MIN_ANSWERS
}

export function isQuestionValidForDone(q: QuestionDraft): boolean {
  return q.saved && isQuestionValidForSave(q)
}

export function areAllQuestionsValidForDone(
  questions: QuestionDraft[],
  productKind: 'test' | 'questionnaire' = 'test'
): boolean {
  if (productKind === 'questionnaire') {
    const answerable = questions.filter((q) => (q.kind ?? 'single') !== 'info')
    if (answerable.length < MIN_QUESTIONS_FOR_DONE_SURVEY) {
      return false
    }
    return questions.every(isQuestionValidForDone)
  }
  if (questions.length < MIN_QUESTIONS_FOR_DONE_TEST) {
    return false
  }
  return questions.every(isQuestionValidForDone)
}
